import { useMutation } from "@apollo/client/react";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { GET_ALL_PARTNERS, UPDATE_PARTNER } from "@/hooks";

export const useUpdatePartner = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [updatePartner, { loading }] = useMutation<any>(UPDATE_PARTNER, {
    refetchQueries: [{ query: GET_ALL_PARTNERS }],
    awaitRefetchQueries: true,
    onCompleted: (response) => {
      if (response.updatePartner?.success) {
        setSuccess(true);
        setResetForm(true);
        enqueueSnackbar("Partner updated successfully", {
          variant: "success",
        });
        setTimeout(() => {
          setSuccess(false);
          setResetForm(false);
        }, 5000);
        onCompleted();
      } else {
        setSuccess(false);
        enqueueSnackbar("Failed to update partner", {
          variant: "error",
        });
      }
    },
    onError: ({ message }) => {
      setSuccess(false);
      enqueueSnackbar(message || "An error occurred while updating partner", {
        variant: "error",
      });
      onError(message);
    },
  });
  return {
    updatePartner,
    updating: loading,
    success,
    resetForm,
  };
};
